import {useContext} from 'react'
import PopUpContext from '../store/providers/PopUpContext'

const usePopupCtx = () => {
  const popUpCtx = useContext(PopUpContext);

  return popUpCtx
}

export default usePopupCtx
